import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	spotlightTitleMessage: {
		id: 'cross-joinable-products-in-switcher.title',
		defaultMessage: 'Join your team in {product}',
		description: 'Title of spotlight when Confluence is being recommended.',
	},
	getStartedButtonText: {
		id: 'cross-joinable-products-in-switcher.getStartedButton.text',
		defaultMessage: 'Get started',
		description: 'Text for the spotlight action button.',
	},
	dismissButtonText: {
		id: 'cross-joinable-products-in-switcher.dismissButton.text',
		defaultMessage: 'No thanks',
		description: 'Text for the spotlight dismiss button.',
	},
	confluenceDescription: {
		id: 'cross-joinable-products-in-switcher.confluence.description',
		defaultMessage:
			'Edit together in real-time, align teams, and unify documentation for faster delivery.',
		description: 'Description of spotlight when Confluence is being recommended.',
	},
	jiraDescription: {
		id: 'cross-joinable-products-in-switcher.request-access-error-flag.description-support-link',
		defaultMessage: 'Plan, organize, and track work in one place to ship projects faster.',
		description: 'Description of spotlight when Jira is being recommended.',
	},
	jiraProductDiscoveryDescription: {
		id: 'cross-joinable-products-in-switcher.request-access-error-flag.description-support-link',
		defaultMessage:
			'Prioritize ideas, plan roadmaps, and unify your workflow from discovery to delivery.',
		description: 'Description of spotlight when Jira Service Management is being recommended..',
	},
	jiraServiceManagementDescription: {
		id: 'cross-joinable-products-in-switcher.request-access-error-flag.description-support-link',
		defaultMessage:
			'Automate workflows and view support requests in one place to deliver faster, superior IT service.',
		description: 'Description of spotlight when Jira Service Management is being recommended.',
	},
});
